
<template>
    <div class="sale-query">
      <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
        <el-form-item label="提货单号" prop="takeOrderNo">
          <el-input v-model="form.takeOrderNo" placeholder="请输入提货单号"></el-input>
        </el-form-item>
        <el-form-item label="发起时间" prop="createTime">
        <el-date-picker
          v-model="form.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        style="width: 100%"
        tooltip-effect="light"
        ref="multipleTable">
        <el-table-column
          prop="takeOrderNo"
          label="销售提货单号"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="ourFlowmeter"
          label="我方流量计"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="loadingDeckQuantity"
          label="装船甲板量"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="unloadingDeckQuantity"
          label="卸船甲板量"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="ourTankOutput"
          label="我方罐出量"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="oppositeFlowMeter"
          label="对方流量计"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="oppositeTankOutput"
          label="对方罐入量"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="updatePerson"
          label="更新人"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          :page-sizes="[10, 20, 50, 100]"
          :page-size="listState.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listState.total"
          :current-page="listState.pageNo"
          background
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange">
        </el-pagination>
        <!-- <div class="output-box" v-permission="'0172301'">
          每页<el-select class="select-page" v-model="form.pageSize" placeholder="请选择条数">
            <el-option
              v-for="item in sizeArr"
              :key="item.value"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>条
          第<el-select class="select-page" v-model="form.pageNo" placeholder="请输入页码">
            <el-option
              v-for="item in sizeNumber"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>页 -->
          <!-- <el-button class="select-page-btn" type="primary"  @click="handleExport()">导出为CSV文件</el-button> -->
        <!-- </div> -->
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatTime } from '../../../../common/utils'
export default {
  name: 'pipelineRehireHistory',
  data () {
    return {
      form: {
        createTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)],
        takeOrderNo: '',
        pageSize: 10
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getPipeLineRehireList', listState: 'getPipeLineRehireListState' }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.form.pageSize) + 1
      const newArr = [...new Array(maxNo).keys()]
      newArr.shift()
      return newArr
    }
  },
  methods: {
    ...mapActions(['getPipelineRehireHistoryList']),
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.form.createTime = [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)]
      this.handleSearch()
    },
    // 搜索
    handleSearch () {
      let newParams = {
        ...this.form,
        startTime: this.form[0] || '',
        endTime: this.form[1] || ''
      }
      this.getPipelineRehireHistoryList({ ...newParams, pageNo: 1, pageSize: 10 })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getPipelineRehireHistoryList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getPipelineRehireHistoryList({ pageNo: val })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

  <style lang="scss">
  .output-box{
  margin-top: 20px;
  text-align: right;
  }
  .input-page, .select-page{
    width: 98px;
    margin: 0 15px;
  }
  .input-page, .select-page-btn{
    width: 120px;
    margin: 0 15px;
  }
  .picktime-box .el-button--text{
    display: none;
  }
  </style>
